import React from 'react';
import { Center, Container } from '@mantine/core';
import { PrivacyChoices } from '@/components/PrivacyChoices';
import ForgotPasswordPolicy from './ForgotPassword.policy';

const ForgotPasswordFooter: React.FC = () => {
  return (
    <>
      <Center>
        <ForgotPasswordPolicy />
      </Center>
      <Container>
        <Center>
          <PrivacyChoices />
        </Center>
      </Container>
    </>
  );
};

export default ForgotPasswordFooter;
